export class SaasGoogleWorkspaceUserProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgUnitPath",
            "baseName": "orgUnitPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "suspended",
            "baseName": "suspended",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "archived",
            "baseName": "archived",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasGoogleWorkspaceUserProperties.attributeTypeMap;
    }
    constructor() {
    }
}
